import { render, staticRenderFns } from "./OrderInfoItem.vue?vue&type=template&id=135df8c2&scoped=true"
import script from "./OrderInfoItem.vue?vue&type=script&lang=js"
export * from "./OrderInfoItem.vue?vue&type=script&lang=js"
import style0 from "./OrderInfoItem.vue?vue&type=style&index=0&id=135df8c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135df8c2",
  null
  
)

export default component.exports